import { styled } from '@compiled/react';

import { token } from '@atlaskit/tokens';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles
export const KnowledgeCardsPicture = styled.img({
	borderRadius: token('radius.full'),
	width: '96px',
	height: '96px',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles
export const PersonStyles = styled.img({
	borderRadius: token('radius.full'),
	width: '32px',
	height: '32px',
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles
export const WorkStyles = styled.img({
	borderRadius: '0',
	width: '24px',
	height: '24px',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles
export const AgentStyles = styled.img({
	borderRadius: token('radius.medium'),
	width: '32px',
	height: '32px',
});
